import React, { Component } from "react";
import { Link } from "react-router-dom";
import Modal from "./modal";

class User extends Component {
  render() {
    return (
      <div className="user-name">
        <div className="container">
          <div className="input-wrap">
            <div id="float-label">
              <input type="text" onChange={this.props.onGetName} />
              <label className={this.props.isLabel} htmlFor="name">
                Name
              </label>
            </div>
          </div>

          <Link
            to="/game"
            className="play_link"
            onClick={() => {
              document.body.style.backgroundImage =
                "linear-gradient(180deg, #390f01, #000)";
            }}
          >
            <button className="playGame">Let's play</button>
          </Link>
          <Modal></Modal>
        </div>
      </div>
    );
  }
}

export default User;
